export enum PartnerCodeLoginSteps {
  HowToProcess,
  ScanCard,
  Register,
  GuestRegister,
  Login,
}
